/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_P2_PreInputs */

const tr_iade_iptal_s10_p2_pre = /** @type {(inputs: Iade_Iptal_S10_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri talepleri`)
};

const en_iade_iptal_s10_p2_pre = /** @type {(inputs: Iade_Iptal_S10_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send data requests to`)
};

const de_iade_iptal_s10_p2_pre = /** @type {(inputs: Iade_Iptal_S10_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenanfragen richten Sie an`)
};

const ru_iade_iptal_s10_p2_pre = /** @type {(inputs: Iade_Iptal_S10_P2_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросы данных направляются на`)
};

/**
* | output |
* | --- |
* | "Send data requests to" |
*
* @param {Iade_Iptal_S10_P2_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_p2_pre = /** @type {((inputs?: Iade_Iptal_S10_P2_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_P2_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_p2_pre(inputs)
	if (locale === "de") return de_iade_iptal_s10_p2_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_p2_pre(inputs)
	return tr_iade_iptal_s10_p2_pre(inputs)
});